export { Layout7 } from "./Layout7";

